import m from "./../../../dist/es2015/locales/it_IT.js";
export const am5locales_it_IT = m;